import React from 'react'


import SvgArrowUpDown from '../../../../../../components/SVG/ArrowUpDown'

import { useSelector } from 'react-redux'
import { cl } from '../../../../../../utilities/cl'

function Header({ sort }) {

    const { sort_field } = useSelector(state => state.videolists.currentVideoListTable)



    return (
        <header className="Songs__control">
            <div className="Songs__grid">
                <div className={cl("id", { "Songs__grid--active": sort_field === 'id' })}>
                    <button
                        className="spp-btn spp-btn_string"
                        onClick={() => sort("id")}
                    >
                        <SvgArrowUpDown className="spp-svg" />
                        ID
                    </button>
                </div>
                
                <div className={cl("composition_video", { "Songs__grid--active": sort_field === 'name' })}>
                    <button
                        className="spp-btn spp-btn_string"
                        onClick={() => sort("name")}
                    >
                        <SvgArrowUpDown className="spp-svg" />
                        ПРОИЗВЕДЕНИЕ
                    </button>
                </div>

                <div className={cl("duration_video", { "Songs__grid--active": sort_field === 'duration' })}>            
                    <button
                        className="spp-btn spp-btn_string"
                        onClick={() => sort("duration")}
                    >
                        <SvgArrowUpDown className="spp-svg" />
                        ДЛИТЕЛЬНОСТЬ
                    </button>
                </div>
                
                <div className={cl("added_video", { "Songs__grid--active": sort_field === 'added' })}>              
                    <button
                        className="spp-btn spp-btn_string"
                        onClick={() => sort("added")}
                    >
                        <SvgArrowUpDown className="spp-svg" />
                        ДОБАВЛЕНО
                    </button>
                </div>
            </div>
        </header>
    )
}

export default Header